// Price/time calculations are independent of canvas coordinates and zoom.
export const DEFAULT_LEVELS = [0,.236,.382,.5,.618,.786,1,1.618,2.618];
export function drawingLevels(settings={}) {
    const input=Array.isArray(settings.levels)?settings.levels:DEFAULT_LEVELS;
    return input.map(x=>typeof x==='number'?{value:x}:x).filter(x=>x && Number.isFinite(x.value) && x.visible!==false).slice(0,32);
}
export function selectedCandles(rows, a, b) {
    const lo=Math.min(a,b),hi=Math.max(a,b);
    return (rows || []).filter(c=>c.length>=5 && c.slice(0,5).every(Number.isFinite) && c[0]>=lo && c[0]<=hi);
}
export function regressionChannel(rows, deviation=2) {
    if(rows.length<2)return null;
    const n=rows.length,meanX=(n-1)/2,meanY=rows.reduce((s,c)=>s+c[4],0)/n;
    let xy=0,xx=0;
    rows.forEach((c,i)=>{xy+=(i-meanX)*(c[4]-meanY);xx+=(i-meanX)**2;});
    const slope=xy/xx,intercept=meanY-slope*meanX;
    const sigma=Math.sqrt(rows.reduce((s,c,i)=>s+(c[4]-intercept-slope*i)**2,0)/n);
    return {slope,intercept,sigma,points:rows.map((c,i)=>[c[0],intercept+slope*i]),offset:sigma*deviation};
}
export function anchoredVWAP(rows,start) {
    let volume=0,sum=0,sum2=0;
    return (rows || []).filter(c=>c[0]>=start).flatMap(c=>{
        const v=c[5],p=(c[2]+c[3]+c[4])/3;
        if(!Number.isFinite(p)||!Number.isFinite(v)||v<0)return [];
        volume+=v;sum+=p*v;sum2+=p*p*v;
        return volume>0?[[c[0],sum/volume,Math.sqrt(Math.max(0,sum2/volume-(sum/volume)**2))]]:[];
    });
}
export function positionLevels(a,b,settings={}) {
    const sign=settings.mode==='short'?-1:1,entry=a[1],risk=Math.abs(b[1]-entry);
    const stop=entry-sign*risk,target=Number.isFinite(settings.target)?settings.target:entry+sign*risk*(settings.rrRatio ?? 3);
    const reward=sign*(target-entry),ratio=risk>0?reward/risk:0;
    const budget=Math.max(0,(settings.accountSize ?? 10000)*(settings.riskPercent ?? 1)/100);
    return {entry,stop,target,risk,reward,ratio,quantity:risk>0?budget/risk:0};
}
export function fibPrices(a,b,c,settings={}) {
    const extension=!!c,reverse=settings.reverse?-1:1;
    const log=!!settings.fibLog && a[1]>0 && b[1]>0 && (!c || c[1]>0);
    const transform=x=>log?Math.log(x):x,untransform=x=>log?Math.exp(x):x;
    // Retracement: 0 at trend end, 1 at trend start. Extension: projected from C.
    const base=transform(extension?c[1]:b[1]);
    const delta=(transform(b[1])-transform(a[1]))*(extension?1:-1)*reverse;
    return drawingLevels(settings).map(level=>({...level,price:untransform(base+delta*level.value)}));
}
export function extendSegment(a,b,width,height,left=false,right=false) {
    const dx=b[0]-a[0],dy=b[1]-a[1],length=Math.hypot(dx,dy);
    if(!length)return [a,b];
    const factor=(Math.hypot(width,height)+Math.hypot(...a)+Math.hypot(...b))/length+1;
    return [left?[a[0]-dx*factor,a[1]-dy*factor]:a,right?[b[0]+dx*factor,b[1]+dy*factor]:b];
}
